/**
 * CdnAssetServiceImplModule
 */
define([
  'js/cdn-asset-service/1.0.0/activity/manifest',
  'js/cdn-asset-service/1.0.0/item/manifest',
  'js/cdn-asset-service/1.0.0/tag/manifest',
  'js/cdn-asset-service/1.0.0/shelf/manifest',
  'js/cdn-asset-service/1.0.0/avatar/manifest',
  'js/cdn-asset-service/1.0.0/compCheck/manifest',
  'js/cdn-asset-service/1.0.0/ui/manifest',
  'js/cdn-asset-service/1.0.0/category/manifest',
  'js/cdn-asset-service/1.0.0/badge/manifest'
], function CdnAssetServiceImplModule(
  ACTIVITY_MANIFEST,
  ITEM_MANIFEST,
  TAG_MANIFEST,
  SHELF_MANIFEST,
  AVATAR_MANIFEST,
  COMP_CHECK_MANIFEST,
  UI_MANIFEST,
  CATEGORY_MANIFEST,
  BADGE_MANIFEST
) {
  'use strict';
  /**
   * CdnAssetServiceImpl
   *
   * @return {Object} Service Impl.
   */
  var CdnAssetServiceImpl = function CdnAssetServiceImpl() {
    var MANIFEST = Object.assign(
      {},
      {activity: ACTIVITY_MANIFEST},
      {item: ITEM_MANIFEST},
      {tag: TAG_MANIFEST},
      {shelf: SHELF_MANIFEST},
      {avatar: AVATAR_MANIFEST},
      {compCheck: COMP_CHECK_MANIFEST},
      {ui: UI_MANIFEST},
      {category: CATEGORY_MANIFEST},
      {badge: BADGE_MANIFEST}
    );

    /**
     * _getTemplate
     *
     * @private
     *
     * @param {String} manifestType Options: 'activity', 'item' and 'tag'
     *
     * @param {String} assetType Options:'image', 'audio', 'icon'
     *
     * @return {String| undefined} Template path
     */
    var _getTemplate = function _getTemplate(manifestType, assetType) {
      return MANIFEST[manifestType]['assets'][assetType];
    };

    /**
     * _getPath
     *
     * @private
     *
     * @param {String} template Template string to parse.
     * 
     * @param {String} platform Only option is 'web'
     *
     * @param {Object} options Vars for template string.
     *
     * @return {String} formatted path
     */
    var _getPath = function _getPath(template, platform, options) {
      var activityId = options.activityId || '';
      var avatarId = options.avatarId || '';
      var compCheckId = options.compCheckId || '';
      var compCheckImage = options.compCheckImage || '';
      var compCheckAudio = options.compCheckAudio || '';
      var compCheckCommonData = options.compCheckCommonData || '';
      var version = options.version || '';
      var audioName = options.audioName || '';
      var file = options.file || '';
      var status = options.status || '';
      var shelfType = options.shelfType || '';
      var shelfId = options.shelfId || '';
      var itemId = options.itemId || '';
      var tagId = options.tagId || '';
      var resolution = options.resolution || '';
      const  badgeId = options.badgeId || '';

      return (template || '')
        .replace(/{tag_id}/g, tagId)
        .replace(/{resolution}/g, resolution)
        .replace(/{item_id}/g, itemId)
        .replace(/{activity_id}/g, activityId)
        .replace(/{comp_check_id}/g, compCheckId)
        .replace(/{comp_check_image}/g, compCheckImage)
        .replace(/{comp_check_audio}/g, compCheckAudio)
        .replace(/{comp_check_common_data}/g, compCheckCommonData)
        .replace(/{version}/g, version)
        .replace(/{audio_name}/g, audioName)
        .replace(/{avatar_id}/g, avatarId)
        .replace(/{url}/g, file)
        .replace(/{platform}/g, platform)
        .replace(/{status}/g, status)
        .replace(/{shelf_type}/g, shelfType)
        .replace(/{shelf_id}/g, shelfId)
        .replace(/{badge_id}/g, badgeId);
    };

    /**
     * getTagImagePath
     *
     *
     * @param {Object} options:
     *                    - tagId
     *                    - file
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getTagImagePath = function getTagImagePath(options) {
      return _getPath(_getTemplate('tag', 'image'), 'web', options);
    };

    /**
     * getAvatarImagePath
     *
     *
     * @param {Object} options:
     *                    - avatarId
     *                    - resolution
     * @return {String} formatted path.
     */
    var getAvatarImagePath = function getAvatarImagePath(options) {
      return _getPath(_getTemplate('avatar', 'image'), 'web', options);
    };

    /**
     * getCompCheckImagePath
     *
     *
     * @param {Object} options:
     *                    - compCheckId
     *                    - version
     *                    - compCheckImage
     * @return {String} formatted path.
     */
    var getCompCheckImagePath = function getCompCheckImagePath(options) {
      return _getPath(_getTemplate('compCheck', 'image'), 'web', options);
    };

    /**
     * getCompCheckAudioPath
     *
     *
     * @param {Object} options:
     *                    - compCheckId
     *                    - version
     *                    - compCheckAudio
     * @return {String} formatted path.
     */
    var getCompCheckAudioPath = function getCompCheckAudioPath(options) {
      return _getPath(_getTemplate('compCheck', 'audio'), 'web', options);
    };

    /**
     * getCompCheckCommonDataPath
     *
     *
     * @param {Object} options:
     *                    - compCheckCommonData
     * @return {String} formatted path.
     */
    var getCompCheckCommonDataPath = function getCompCheckCommonDataPath(options) {
      return _getPath(_getTemplate('compCheck', 'commonData'), 'web', options);
    };

    /**
     * getActivityAudioPath
     *
     *
     * @param {Object} options:
     *                    - activityId
     *                    - file
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getActivityAudioPath = function getActivityAudioPath(options) {
      return _getPath(_getTemplate('activity', 'audio'), 'web', options);
    };

    /**
     * getUIAudioPath
     *
     *
     * @param {Object} options:
     *                    - audioName
     * @return {String} formatted path.
     */
    var getUIAudioPath = function getUIAudioPath(options) {
      return _getPath(_getTemplate('ui', 'audio'), 'web', options);
    };

    /**
     * getTagAudioPath
     *
     *
     * @param {Object} options:
     *                    - tagId
     * @return {String} formatted path.
     */
    var getTagAudioPath = function getTagAudioPath(options) {
      return _getPath(_getTemplate('tag', 'audio'), 'web', options);
    };

    /**
     * getItemAudioPath
     *
     *
     * @param {Object} options:
     *                    - itemId
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getItemAudioPath = function getItemAudioPath(options) {
      return _getPath(_getTemplate('item', 'audio'), 'web', options);
    };

    /**
     * getItemIconPath
     *
     *
     * @param {Object} options:
     *                    - activityId
     *                    - file
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getItemIconPath = function getItemIconPath(options) {
      var path = _getPath(_getTemplate('item', 'icon'), 'web', options)
      return aofljsConfig.isWebPSupported ? path.replace(/\.png/,'.webp') : path;
    };

    /**
     * getCategoryIconPath
     *
     *
     * @param {Object} options:
     *                    - itemId
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getCategoryIconPath = function getCategoryIconPath(options) {
      return _getPath(_getTemplate('category', 'icon'), 'web', options);
    };

    /**
     * getActivityImagePath
     *
     *
     * @param {Object} options:
     *                    - activityId
     *                    - file
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getActivityImagePath = function getActivityImagePath(options) {
      return _getPath(_getTemplate('activity', 'image'), 'web', options);
    };

    /**
     * getActivityVideoPath
     *
     *
     * @param {Object} options:
     *                    - activityId
     *                    - file
     *                    - platform
     *                    - status
     *                    - shelfType
     * @return {String} formatted path.
     */
    var getActivityVideoPath = function getActivityVideoPath(options) {
      return _getPath(_getTemplate('activity', 'video'), 'web', options);
    };

    /**
     * getShelfAudioPath
     *
     * @param {Object} options:
     *                    - shelfId
     * @return {String} formatted path.
     */
    var getShelfAudioPath = function getShelfAudioPath(options) {
      return _getPath(_getTemplate('shelf', 'audio'), 'web', options);
    };

    var getBadgeIconPath = function getBadgeIconPath(options) {
      return _getPath(_getTemplate('badge','icon'),'web',options)
    }

    return {
      getActivityAudioPath: getActivityAudioPath,
      getItemIconPath: getItemIconPath,
      getActivityImagePath: getActivityImagePath,
      getActivityVideoPath: getActivityVideoPath,
      getTagImagePath: getTagImagePath,
      getShelfAudioPath: getShelfAudioPath,
      getTagAudioPath: getTagAudioPath,
      getItemAudioPath: getItemAudioPath,
      getAvatarImagePath: getAvatarImagePath,
      getCompCheckImagePath: getCompCheckImagePath,
      getCompCheckAudioPath: getCompCheckAudioPath,
      getCompCheckCommonDataPath: getCompCheckCommonDataPath,
      getUIAudioPath: getUIAudioPath,
      getCategoryIconPath: getCategoryIconPath,
      getBadgeIconPath
    };
  };

  return CdnAssetServiceImpl;
});
